import WelcomeText from './welcome-text'
export default (WelcomeText)